// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_main_css-src_utils_assets_css_normilize_css-src_utils_assets_fonts_Inter_inter_css-src_ut-fed09f":"d69fe8ecce48707da078","node_modules_shoelace-style_shoelace_dist_themes_light_css":"e6d4c40bbe382dfc6801"}[chunkId] + ".css";
};